import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const TermsOfService = () => {
    return (
        <div className="min-h-screen bg-background text-text-primary">
            <Helmet>
                <title>Terms of Service - Northbridge Valuation & Advisory</title>
                <meta name="description" content="Terms of Service for Northbridge Valuation & Advisory website and professional services." />
            </Helmet>
            <Header />

            <main className="max-w-4xl mx-auto px-6 py-20">
                <h1 className="text-4xl lg:text-5xl font-bold text-primary mb-4">Terms of Service</h1>
                <p className="text-text-secondary mb-12">Last Updated: January 1, 2026</p>

                <div className="space-y-10 prose prose-slate max-w-none">
                    <section>
                        <h2 className="text-2xl font-bold text-primary mb-4">1. Acceptance of Terms</h2>
                        <p className="text-text-secondary leading-relaxed">
                            By accessing northbridgevaluation.com or utilizing the services of Northbridge Valuation & Advisory, you agree to comply with and be bound by these Terms of Service. If you do not agree, please refrain from using our site or services.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-primary mb-4">2. Scope of Services</h2>
                        <p className="text-text-secondary leading-relaxed">
                            Northbridge Valuation & Advisory provides professional valuation of private business interests, estate/gift tax valuations, and litigation support. The information provided on our website is for general informational purposes only and does not constitute legal, tax, or financial advice.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-primary mb-4">3. No Professional-Client Relationship</h2>
                        <p className="text-text-secondary leading-relaxed">
                            Use of this website or communication with our team via email/contact forms does not establish a formal professional-client relationship. Such a relationship is only formed once a written Engagement Letter has been signed by both an authorized representative of Northbridge Valuation & Advisory and the client.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-primary mb-4">4. Intellectual Property</h2>
                        <p className="text-text-secondary leading-relaxed">
                            All content on this website, including text, logos (including the Northbridge logo), graphics, and digital downloads, is the property of Northbridge Valuation & Advisory and is protected by copyright and trademark laws. Unauthorized use of this material is prohibited.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-primary mb-4">5. Limitation of Liability</h2>
                        <p className="text-text-secondary leading-relaxed">
                            In no event shall Northbridge Valuation & Advisory, its principals, or employees be liable for any indirect, incidental, or consequential damages arising out of the use of our website or reliance on its content. Our liability regarding professional engagements is strictly governed by the terms set forth in our signed Engagement Letters.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-primary mb-4">6. User Conduct</h2>
                        <p className="text-text-secondary mb-4 italic leading-relaxed">Users agree not to:</p>
                        <ul className="list-disc pl-5 space-y-3 text-text-secondary">
                            <li>Use the website for any unlawful purpose.</li>
                            <li>Attempt to interfere with the security or proper functioning of the website.</li>
                            <li>Submit false or misleading information via contact forms.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-primary mb-4">7. Third-Party Links</h2>
                        <p className="text-text-secondary leading-relaxed">
                            Our website may contain links to third-party websites (e.g., industry resources). We do not control these sites and are not responsible for their content or privacy practices.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-primary mb-4">8. Governing Law</h2>
                        <p className="text-text-secondary leading-relaxed">
                            These terms are governed by and construed in accordance with the laws of the State of Wyoming, without regard to its conflict of law principles.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-primary mb-4">9. Modifications</h2>
                        <p className="text-text-secondary leading-relaxed">
                            We reserve the right to revise these Terms of Service at any time without notice. By using this website, you are agreeing to be bound by the then-current version of these Terms of Service.
                        </p>
                    </section>

                </div>
            </main>

            <Footer />
        </div>
    );
};

export default TermsOfService;
